import React, { useEffect, useState } from 'react';

import { Button, Text, Title, toastService } from '@thefarmersfront/kitchen';

import { PageWrapper } from '~/components/layout';
import { VenderChangePasswordModal } from '~/components/vender';

import { useModal } from '~/hooks/common';
import { useGetOwnerManagerDetail } from '~/hooks/vender';
import { useLoadingStore } from '~/store';

import type { TypeErrorResponseData } from '~/types/common.types';
import { TypeGetOwnerManagerDetail } from '~/types/vender.types';

import styles from './VenderModifyPage.module.scss';

const VenderConfirmPage = () => {
  const { getOwnerManagerDetail } = useGetOwnerManagerDetail();

  const { setIsLoading } = useLoadingStore();

  const [managerDetail, setManagerDetail] = useState<TypeGetOwnerManagerDetail>();

  const {
    isOpen: isOpenChangePasswordModal,
    handleOpenModal: handleOpenChangePasswordModal,
    handleCloseModal: handleCloseChangePasswordModal,
    handleConfirmModal: handleConfirmChangePasswordModal,
  } = useModal();

  const fetchManagerDetail = async () => {
    try {
      setIsLoading(true);

      const data = await getOwnerManagerDetail();

      setManagerDetail(data);
    } catch (error) {
      toastService.addToast({
        type: 'error',
        message:
          (error as TypeErrorResponseData['error'])?.message ?? '정보를 가져오지 못했습니다. 다시 시도해 주세요.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchManagerDetail();
  }, []);

  return (
    <>
      <PageWrapper>
        <div className={styles['title-section']}>
          <Title>개인정보관리</Title>
        </div>
        <div className={styles['view-section-box']}>
          <div className={styles['info-item']}>
            <Text className={styles['info-label']} size="large" weight="semi-bold">
              아이디
            </Text>
            <Text size="large">{managerDetail?.ownerLoginId}</Text>
          </div>
          <div className={styles['info-item']}>
            <Text className={styles['info-label']} size="large" weight="semi-bold">
              비밀번호
            </Text>
            <Button size="small" color="secondary" onClick={handleOpenChangePasswordModal}>
              변경
            </Button>
          </div>
          <div className={styles['info-item']}>
            <Text className={styles['info-label']} size="large" weight="semi-bold">
              담당자명
            </Text>
            <Text size="large">{managerDetail?.ownerManagerName}</Text>
          </div>
          <div className={styles['info-item']}>
            <Text className={styles['info-label']} size="large" weight="semi-bold">
              직위
            </Text>
            <Text size="large">{managerDetail?.ownerManagerPosition}</Text>
          </div>
          <div className={styles['info-item']}>
            <Text className={styles['info-label']} size="large" weight="semi-bold">
              휴대폰 번호
            </Text>
            <Text size="large">{managerDetail?.ownerManagerTel}</Text>
          </div>
          <div className={styles['info-item']}>
            <Text className={styles['info-label']} size="large" weight="semi-bold">
              이메일
            </Text>
            <Text size="large">{managerDetail?.ownerManagerEmail}</Text>
          </div>
        </div>
      </PageWrapper>
      {isOpenChangePasswordModal && (
        <VenderChangePasswordModal
          open={isOpenChangePasswordModal}
          onCancel={handleCloseChangePasswordModal}
          onConfirm={handleConfirmChangePasswordModal}
        />
      )}
    </>
  );
};

export default VenderConfirmPage;
